// FIX-886 — /static is served with a one-year max-age (vercel.json): without a
// new URL, a browser that already opened a previous PDF would keep showing it.
// Bump `v` with every new static/PolitiqueDeConfidentialite.pdf.
const PRIVACY_POLICY_URL =
  '/static/PolitiqueDeConfidentialite.pdf?v=2026-10-13';

export default PRIVACY_POLICY_URL;
